import { IRoute } from '@/configs/define'

const routes:Array<IRoute> = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/largeScreen',
    name: 'largeScreen',
    component: () => import('@/views/largeScreen/index.vue'),
    meta: {
      title: '大屏',
      auth: true,
    },
  },
]
export default routes
